var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinesAnimation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "subway-animation",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2200 1800",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "traintrax",
    stroke: "#b933ad",
    d: "M 2144.2 734 L 1493.5 734 C 1483.7 734 1474.4 730.1 1467.5 723.2 L 874.9 130.7 M 1252.4 508.2 L 1263.1 518.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "purpleline trainbase",
    d: "M2144.2,734h-650.7c-9.8,0-19.1-3.9-26-10.8 L874.9,130.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "traintrax",
    stroke: "#00933c",
    d: "M 2110.5 321.3 L 1925.9 505.9 C 1919 512.8 1909.6 516.7 1899.9 516.7 L 1802.3 516.7 C 1788.7 516.7 1777.8 527.7 1777.8 541.2 L 1777.8 555.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "traintrax",
    stroke: "#00933c",
    d: "M 1777.7 125 L 1777.7 1343.5 C 1777.7 1363.8 1761.2 1380.3 1740.9 1380.3 L 911.9 1380.3 C 902.1 1380.3 892.8 1384.2 885.9 1391.1 L 613.3 1673.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "greenline trainbase",
    d: "M 2110.5 321.3 L 1925.9 505.9 C 1919 512.8 1909.6 516.7 1899.9 516.7 L 1802.3 516.7 C 1788.7 516.7 1777.8 527.7 1777.8 541.2 L 1777.8 555.2 L 1777.8 1343.5 C 1777.8 1363.8 1761.3 1380.3 1741 1380.3 L 911.9 1380.3 C 902.1 1380.3 892.8 1384.2 885.9 1391.1 L 613.3 1673.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "traintrax",
    stroke: "#fccc0a",
    d: "M 1797.1 1038.2 L 1797.1 992.7 M 1797.1 1672.4 L 1797.1 615.3 C 1797.1 601.8 1786.1 590.8 1772.6 590.8 L 1559.9 590.8 C 1550.8 590.8 1542.2 594.6 1536 601.2 L 1454.3 688.5 C 1448.1 695.1 1439.5 698.9 1430.4 698.9 L 434.9 698.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "yellowline trainbase",
    d: "M1797.1,1672.4V615.3c0-13.5-11-24.5-24.5-24.5 h-212.7c-9.1,0-17.7,3.8-23.9,10.4l-81.7,87.3c-6.2,6.6-14.8,10.4-23.9,10.4H434.9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesAnimation);
export default __webpack_public_path__ + "static/media/lines-animation.614d9f5c26bc61b98ad79ea154a9e15c.svg";
export { ForwardRef as ReactComponent };